import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition';
import { isLocaleEnglish } from '@confluence/onboarding-helpers/entry-points/isLocaleEnglish';
import { useSessionData } from '@confluence/session-data';

/** Checks elgibility for Mention On Restricted Page experiment. */
export function useIsMentionOnRestrictedPageEligible(): boolean {
	const { edition, locale } = useSessionData();
	const isPaidEdition = edition !== ConfluenceEdition.FREE;

	// Must be paid edition
	if (!isPaidEdition) {
		return false;
	}

	// Must be English locale
	if (!isLocaleEnglish(locale)) {
		return false;
	}

	return true;
}
